import { EMovementType } from '../enums/EStock';
import { IColor } from '../interfaces/color';

const getStockMovementStatusName = (status: EMovementType): string => {
  switch (status) {
    case EMovementType.IN:
      return 'รับเข้า';
    case EMovementType.OUT:
      return 'เบิกจ่าย';
    case EMovementType.CLEAR:
      return 'ปรับปรุง';
    default:
      return '';
  }
};

const getStockMovementStatusColor = (status: EMovementType): IColor => {
  let color: IColor = {
    bg: 'bg-blue-200',
    text: 'text-black',
  };
  switch (status) {
    case EMovementType.IN:
      color = {
        bg: 'bg-green-100',
        text: 'green',
      };
      break;
    case EMovementType.OUT:
      color = {
        bg: 'bg-red-100',
        text: 'red',
      };
      break;
  }
  return color;
};

export { getStockMovementStatusName, getStockMovementStatusColor };
